import * as Types from '../../../../@types/graphql-types';

import gql from 'graphql-tag';
import { SingleStepSportEventFragmentDoc } from '../fragments/SingleStepSportEvent.fragment';
import { SportEventOffersV2FragmentDoc } from '../fragments/SportEventOffersV2.fragment';
import { MultiStepSportEventFragmentDoc } from '../fragments/MultiStepSportEvent.fragment';
import { SportEventBundleFragmentDoc } from '../fragments/SportEventBundle.fragment';
export type GetSportEventV2QueryVariables = Types.Exact<{
	fullPath: Types.Scalars['String']['input'];
	site?: Types.InputMaybe<Types.Scalars['String']['input']>;
	country: Types.Scalars['Country']['input'];
	language: Types.Scalars['Language']['input'];
	platform: Types.Platform;
}>;

export type GetSportEventV2Query = {
	__typename?: 'Query';
	urlV2: {
		__typename?: 'Url';
		id: string;
		urlID: number;
		locale: string;
		objectType: Types.ObjectType;
		fullPath: string;
		heading1?: string | null;
		heading2?: string | null;
		metaTitle?: string | null;
		metaDescription?: string | null;
		metaRobots?: string | null;
		metaKeywords?: string | null;
		htmlContent?: string | null;
		htmlContentJson?: any | null;
		hrefLangTags: Array<{ __typename?: 'HrefLangTag'; locale: string; hrefLang: string; href: string }>;
		node:
			| { __typename?: 'Article'; id: string }
			| { __typename?: 'Author'; id: string }
			| { __typename?: 'Bundle'; id: string }
			| { __typename?: 'Device'; id: string }
			| { __typename?: 'Episode'; id: string }
			| { __typename?: 'GenericTitleList'; id: string }
			| { __typename?: 'Genre'; id: string }
			| { __typename?: 'HomePage'; id: string }
			| { __typename?: 'Movie'; id: string }
			| {
					__typename: 'MultiStepSportEvent';
					sport: Types.SportType;
					id: string;
					objectType: Types.ObjectType;
					objectId: number;
					offerCount: number;
					content: {
						__typename?: 'MultiStepSportEventContent';
						name: string;
						status: Types.SportEventStatus;
						fullPath?: string | null;
						startAt: any;
						venue?: {
							__typename?: 'SportVenue';
							venueID: number;
							name: string;
							city: string;
							country: any;
						} | null;
						season?: { __typename?: 'SportSeason'; seasonID: number; name: string } | null;
						backdrops: Array<{
							__typename?: 'Backdrop';
							backdropUrl: string;
							backdropBlurHash?: string | null;
						}>;
						competitionStage: {
							__typename?: 'SportCompetitionStageV2';
							name: Types.SportCompetitionStageName;
							number?: number | null;
						};
					};
					competition?: {
						__typename?: 'SportCompetitionV2';
						id: string;
						objectType: Types.ObjectType;
						objectId: number;
						sport: Types.SportType;
						activeSeason?: { __typename?: 'SportSeason'; name: string; seasonID: number } | null;
						content: { __typename?: 'SportCompetitionContentV2'; name: string; fullPath: string };
					} | null;
					mysportlistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
					children: Array<{
						__typename?: 'MultiStepSportEvent';
						id: string;
						objectId: number;
						objectType: Types.ObjectType;
						offerCount: number;
						content: {
							__typename?: 'MultiStepSportEventContent';
							name: string;
							startAt: any;
							endAt?: any | null;
							status: Types.SportEventStatus;
							venue?: { __typename?: 'SportVenue'; venueID: number; name: string } | null;
							competitionStage: {
								__typename?: 'SportCompetitionStageV2';
								name: Types.SportCompetitionStageName;
								number?: number | null;
							};
						};
						watchNowOffer?: {
							__typename?: 'SportOffer';
							monetizationType: Types.MonetizationType;
							presentationType: Types.PresentationType;
							audioLanguage?: string | null;
							standardWebURL?: string | null;
							sportObjectType: Types.SportObjectType;
							package: {
								__typename?: 'Package';
								id: string;
								packageId: number;
								technicalName: string;
								clearName: string;
								shortName: string;
								monetizationTypes: Array<Types.MonetizationType>;
								iconWide: string;
							};
						} | null;
						offers: Array<{
							__typename?: 'SportOffer';
							monetizationType: Types.MonetizationType;
							presentationType: Types.PresentationType;
							audioLanguage?: string | null;
							standardWebURL?: string | null;
							sportObjectType: Types.SportObjectType;
							package: {
								__typename?: 'Package';
								id: string;
								packageId: number;
								technicalName: string;
								clearName: string;
								shortName: string;
								monetizationTypes: Array<Types.MonetizationType>;
							};
						}>;
					}>;
					watchNowOffer?: {
						__typename?: 'SportOffer';
						monetizationType: Types.MonetizationType;
						presentationType: Types.PresentationType;
						audioLanguage?: string | null;
						standardWebURL?: string | null;
						sportObjectType: Types.SportObjectType;
						package: {
							__typename?: 'Package';
							id: string;
							packageId: number;
							technicalName: string;
							clearName: string;
							shortName: string;
							monetizationTypes: Array<Types.MonetizationType>;
							iconWide: string;
						};
					} | null;
					offers: Array<{
						__typename?: 'SportOffer';
						monetizationType: Types.MonetizationType;
						presentationType: Types.PresentationType;
						audioLanguage?: string | null;
						standardWebURL?: string | null;
						sportObjectType: Types.SportObjectType;
						package: {
							__typename?: 'Package';
							id: string;
							packageId: number;
							technicalName: string;
							clearName: string;
							shortName: string;
							monetizationTypes: Array<Types.MonetizationType>;
						};
					}>;
					bundles: Array<{
						__typename?: 'PromotedSportBundleEdge';
						sportPromotionUrl: string;
						node: {
							__typename?: 'Bundle';
							id: string;
							clearName: string;
							technicalName: string;
							bundleId: number;
							packages: Array<{
								__typename?: 'Package';
								id: string;
								icon: string;
								clearName: string;
								packageId: number;
							}>;
						};
						offer: {
							__typename?: 'SportOffer';
							monetizationType: Types.MonetizationType;
							presentationType: Types.PresentationType;
							audioLanguage?: string | null;
							standardWebURL?: string | null;
							sportObjectType: Types.SportObjectType;
							package: {
								__typename?: 'Package';
								id: string;
								packageId: number;
								technicalName: string;
								clearName: string;
								shortName: string;
								monetizationTypes: Array<Types.MonetizationType>;
							};
						};
					}>;
					parent?: {
						__typename?: 'MultiStepSportEvent';
						id: string;
						content: {
							__typename?: 'MultiStepSportEventContent';
							name: string;
							fullPath?: string | null;
							startAt: any;
							status: Types.SportEventStatus;
						};
					} | null;
			  }
			| { __typename?: 'Offer'; id: string }
			| { __typename?: 'OfferHistory'; id: string }
			| { __typename?: 'Package'; id: string }
			| { __typename?: 'Page'; id: string }
			| { __typename?: 'Person'; id: string }
			| { __typename?: 'ProfileV2'; id: string }
			| { __typename?: 'Season'; id: string }
			| { __typename?: 'Show'; id: string }
			| {
					__typename: 'SingleStepSportEvent';
					sport: Types.SportType;
					id: string;
					objectType: Types.ObjectType;
					objectId: number;
					offerCount: number;
					content: {
						__typename?: 'SingleStepSportEventContent';
						name: string;
						status: Types.SportEventStatus;
						fullPath?: string | null;
						startAt: any;
						endAt?: any | null;
						venue?: {
							__typename?: 'SportVenue';
							venueID: number;
							name: string;
							city: string;
							country: any;
						} | null;
						season?: { __typename?: 'SportSeason'; seasonID: number; name: string } | null;
						backdrops: Array<{
							__typename?: 'Backdrop';
							backdropUrl: string;
							backdropBlurHash?: string | null;
						}>;
						competitionStage: {
							__typename?: 'SportCompetitionStageV2';
							name: Types.SportCompetitionStageName;
							number?: number | null;
						};
						pastEvents: Array<{
							__typename?: 'SingleStepSportEvent';
							id: string;
							objectId: number;
							objectType: Types.ObjectType;
							sport: Types.SportType;
							competition?: {
								__typename?: 'SportCompetitionV2';
								id: string;
								objectId: number;
								objectType: Types.ObjectType;
								sport: Types.SportType;
								content: { __typename?: 'SportCompetitionContentV2'; fullPath: string; name: string };
							} | null;
							competitors: {
								__typename?: 'SingleStepSportCompetitorsV2';
								homeTeam: {
									__typename?: 'SingleStepSportCompetitorV2';
									score?: number | null;
									competitors: Array<{
										__typename?: 'SportCompetitorV2';
										id: string;
										objectId: number;
										objectType: Types.ObjectType;
										sport: Types.SportType;
										content: {
											__typename?: 'SportCompetitorContentV2';
											firstName: string;
											fullPath?: string | null;
											lastName: string;
											name: string;
											iconUrl?: string | null;
										};
									}>;
								};
								awayTeam: {
									__typename?: 'SingleStepSportCompetitorV2';
									score?: number | null;
									competitors: Array<{
										__typename?: 'SportCompetitorV2';
										id: string;
										objectId: number;
										objectType: Types.ObjectType;
										sport: Types.SportType;
										content: {
											__typename?: 'SportCompetitorContentV2';
											firstName: string;
											fullPath?: string | null;
											lastName: string;
											name: string;
											iconUrl?: string | null;
										};
									}>;
								};
							};
							content: {
								__typename?: 'SingleStepSportEventContent';
								name: string;
								startAt: any;
								status: Types.SportEventStatus;
								season?: { __typename?: 'SportSeason'; name: string; seasonID: number } | null;
							};
						}>;
					};
					mysportlistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
					competition?: {
						__typename?: 'SportCompetitionV2';
						id: string;
						objectId: number;
						sport: Types.SportType;
						activeSeason?: { __typename?: 'SportSeason'; name: string; seasonID: number } | null;
						content: {
							__typename?: 'SportCompetitionContentV2';
							name: string;
							fullPath: string;
							iconUrl?: string | null;
						};
					} | null;
					watchNowOffer?: {
						__typename?: 'SportOffer';
						monetizationType: Types.MonetizationType;
						presentationType: Types.PresentationType;
						audioLanguage?: string | null;
						standardWebURL?: string | null;
						sportObjectType: Types.SportObjectType;
						package: {
							__typename?: 'Package';
							id: string;
							packageId: number;
							technicalName: string;
							clearName: string;
							shortName: string;
							monetizationTypes: Array<Types.MonetizationType>;
							iconWide: string;
						};
					} | null;
					offers: Array<{
						__typename?: 'SportOffer';
						monetizationType: Types.MonetizationType;
						presentationType: Types.PresentationType;
						audioLanguage?: string | null;
						standardWebURL?: string | null;
						sportObjectType: Types.SportObjectType;
						package: {
							__typename?: 'Package';
							id: string;
							packageId: number;
							technicalName: string;
							clearName: string;
							shortName: string;
							monetizationTypes: Array<Types.MonetizationType>;
						};
					}>;
					bundles: Array<{
						__typename?: 'PromotedSportBundleEdge';
						sportPromotionUrl: string;
						node: {
							__typename?: 'Bundle';
							id: string;
							clearName: string;
							technicalName: string;
							bundleId: number;
							packages: Array<{
								__typename?: 'Package';
								id: string;
								icon: string;
								clearName: string;
								packageId: number;
							}>;
						};
						offer: {
							__typename?: 'SportOffer';
							monetizationType: Types.MonetizationType;
							presentationType: Types.PresentationType;
							audioLanguage?: string | null;
							standardWebURL?: string | null;
							sportObjectType: Types.SportObjectType;
							package: {
								__typename?: 'Package';
								id: string;
								packageId: number;
								technicalName: string;
								clearName: string;
								shortName: string;
								monetizationTypes: Array<Types.MonetizationType>;
							};
						};
					}>;
					competitors: {
						__typename?: 'SingleStepSportCompetitorsV2';
						homeTeam: {
							__typename?: 'SingleStepSportCompetitorV2';
							score?: number | null;
							winner: boolean;
							competitors: Array<{
								__typename?: 'SportCompetitorV2';
								id: string;
								objectId: number;
								content: {
									__typename?: 'SportCompetitorContentV2';
									name: string;
									iconUrl?: string | null;
									fullPath?: string | null;
								};
							}>;
						};
						awayTeam: {
							__typename?: 'SingleStepSportCompetitorV2';
							score?: number | null;
							winner: boolean;
							competitors: Array<{
								__typename?: 'SportCompetitorV2';
								id: string;
								objectId: number;
								content: {
									__typename?: 'SportCompetitorContentV2';
									name: string;
									iconUrl?: string | null;
									fullPath?: string | null;
								};
							}>;
						};
					};
			  }
			| { __typename?: 'SportCompetitionV2'; id: string }
			| { __typename?: 'SportCompetitorV2'; id: string }
			| { __typename?: 'SportMatch'; id: string }
			| { __typename?: 'Url'; id: string };
	};
};

export const GetSportEventV2Document = gql`
	query GetSportEventV2(
		$fullPath: String!
		$site: String
		$country: Country!
		$language: Language!
		$platform: Platform!
	) {
		urlV2(fullPath: $fullPath, site: $site) {
			id
			urlID
			locale
			objectType
			fullPath
			heading1
			heading2
			metaTitle
			metaDescription
			metaRobots
			metaKeywords
			hrefLangTags {
				locale
				hrefLang
				href
			}
			htmlContent
			htmlContentJson
			node {
				id
				... on SportEventV2 {
					sport
					content(country: $country, language: $language) {
						name
						status
						venue {
							venueID
							name
							city
							country
						}
						season {
							seasonID
							name
						}
						backdrops {
							backdropUrl
							backdropBlurHash
						}
						fullPath
					}
				}
				...SingleStepSportEvent
				...MultiStepSportEvent
				...SportEventOffersV2
				...SportEventBundle
			}
		}
	}
	${SingleStepSportEventFragmentDoc}
	${MultiStepSportEventFragmentDoc}
	${SportEventOffersV2FragmentDoc}
	${SportEventBundleFragmentDoc}
`;
